import { ordersActions } from '../../../../redux/actions/medication/drugs/orders';

const initialState = {
  orders: [], // List of orders
  loading: false, // Indicates loading state for any action
  error: null // Captures error details, if any
};

/**
 * Orders Reducer
 * Manages state transitions for order operations such as fetching, creating, and deleting orders.
 *
 * @param {Object} state - The current state of the orders reducer.
 * @param {Object} action - The dispatched action containing `type` and `payload`.
 * @returns {Object} The updated state after processing the action.
 */
const ordersReducer = (state = initialState, action) => {
  const { type, payload, error } = action;

  switch (type) {
    // Request states for all order operations
    case ordersActions.FETCH_ORDERS.REQUEST:
    case ordersActions.POST_ORDERS.REQUEST:
    case ordersActions.DELETE_ORDER.REQUEST:
      return {
        ...state,
        loading: true,
        error: null // Clear any previous error
      };

      // Success: Fetch orders
    case ordersActions.FETCH_ORDERS.SUCCESS:
      return {
        ...state,
        loading: false,
        orders: payload // Replace existing orders with the fetched list
      };

      // Success: Create a new order
    case ordersActions.POST_ORDERS.SUCCESS:
      return {
        ...state,
        loading: false,
        orders: [...state.orders, payload] // Append the new order
      };

      // Success: Delete an order
    case ordersActions.DELETE_ORDER.SUCCESS:
      return {
        ...state,
        loading: false,
        orders: state.orders.filter(order => order.id !== payload) // Remove the deleted order
      };

      // Failure states for all order operations
    case ordersActions.FETCH_ORDERS.FAILURE:
    case ordersActions.POST_ORDERS.FAILURE:
    case ordersActions.DELETE_ORDER.FAILURE:
      return {
        ...state,
        loading: false,
        error // Capture the error details
      };

      // Default: Return unchanged state for unrecognized actions
    default:
      return state;
  }
};

export default ordersReducer;
